import { render, staticRenderFns } from "./ReturnConfirmation.vue?vue&type=template&id=04aa036d&scoped=true&"
import script from "./ReturnConfirmation.vue?vue&type=script&lang=js&"
export * from "./ReturnConfirmation.vue?vue&type=script&lang=js&"
import style0 from "./ReturnConfirmation.vue?vue&type=style&index=0&id=04aa036d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aa036d",
  null
  
)

export default component.exports